import React from 'react';

const POSButton = ({ title, onClick, color, size, ...rest }) => (
  <button
    type="button"
    className={`pos-button pos-button__${size || 'default'} pos-button__color-${
      color || 'default'
    }`}
    {...rest}
    onClick={onClick}
  >
    {title}
  </button>
);

export default POSButton;
